import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = () => {
  useEffect(() => {
    //toast.success("Component mounted successfully!");
  }, []); // Empty dependency array means it runs only once on mount

  return (
    <div>
      <ToastContainer /> {/* Ensure the ToastContainer is present */}
    </div>
  );
};

export default App;
